import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PrimaryGradientButton from './PrimaryGradientButton';
import PrimaryOutLineButton from './PrimaryOutLineButton';
import { Col, Container, Row } from 'react-bootstrap';
import AlertMsg from './AlertMsg';
const ConfirmationModal = ({ isLoginSuccessHeading, isLoginSuccessCondition, isLoginSuccessText, modalTitle, showAlert, modalDescription, isModalOpen, setIsModalOpen, page, onReviewSubmit, outlinebuttonText, onClick, isButtonLoading }) => {
    const handleClose = () => setIsModalOpen(false);
    return (
        <>
            <Modal show={isModalOpen} onHide={handleClose}>
                {page === 'eKYCResponse' && (
                    <>
                        <Modal.Header closeButton>
                            <Modal.Title>{modalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <div className='panCardConfirmationWrap'>
                                <div className='panCardConfirmation'>
                                    <label>Yes</label>

                                    <input type="radio" name="yes" value="Yes" onClick={() => onClick("Yes")} />
                                </div>

                                <div className='panCardConfirmation'>
                                    <label>No</label>
                                    <input type="radio" name="yes" value="Yes" onClick={() => onClick("No")} />
                                </div>
                            </div>
                        </Modal.Body>
                    </>
                )}
                {(page === 'myOrders' || page === 'dynamicKyc') && (

                    <>
                        <Modal.Header closeButton>
                            <Modal.Title>{modalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {!showAlert &&
                                <>
                                    <p className='myOrderConfirm'>{modalDescription}</p>
                                    <div className='confirmBtnBlock'>
                                        <Button variant="danger" disabled={isButtonLoading} onClick={() => onReviewSubmit('No')}>No</Button>
                                        <Button variant="success" disabled={isButtonLoading} onClick={() => onReviewSubmit('Yes')}>{isButtonLoading ? 'Processing...' : 'Yes'}</Button>
                                    </div>
                                </>
                            }

                            {showAlert &&
                                <Col xs={12} className='mt-3'>
                                    <AlertMsg alertBoxColor={isLoginSuccessCondition ? 'successAlert' : 'FailedAlert'}
                                        heading={isLoginSuccessHeading}
                                        text={isLoginSuccessText} />

                                </Col>
                            }
                        </Modal.Body>

                    </>
                )}

                {/* {!showAlert && <Modal.Footer>
                    <Container>
                        <Row className='justify-content-center'>
                            <Col xs={12} md={6}>
                                <PrimaryGradientButton buttonText="Close" onClick={handleClose} />
                            </Col>
                        </Row>
                    </Container>

                </Modal.Footer>} */}
            </Modal>
        </>
    )
}

export default ConfirmationModal